export default __webpack_public_path__ + "static/media/instadelivery.aa302101.png";